import React from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "types/store";
import { Button } from "aible";
import * as nextReducer from "containers/Next/NextReducer";
import * as homeReducer from "containers/Home/reducer";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import styles from "./style.module.css";
import ToneSelector from "components/ChatGPT/ToneSettings/ToneSelector";
import BlueprintSelector from "components/ChatGPT/BlueprintSelector";
import { format, parse } from "date-fns";
import ModelSelector from "components/ChatGPT/ModelSelector";
import DateSelector from "components/ChatGPT/Dashboard/DateSelector";
import DateInput from "components/ChatGPT/Dashboard/DateInput";
import LabledToggle from "components/Inputs/Toggle/Toggle";
import KPIAdvancedSettings from "components/KPIAnalysis/KPIAdvancedSettings";
// Should split this out to a seperate file and join the reference and current together
const KPIDatePeriodSelector = () => {
    const dispatch = useDispatch();
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const timeBucket = useSelector((state) => homeReducer.getKPIAnalysisTimeBucket(state, datasetId));
    const KPIDateRangeReferenceStart = useSelector((state) => chatGPTReducer.getKPIDateRangeReferenceStart(state));
    const KPIDateRangeReferenceEnd = useSelector((state) => chatGPTReducer.getKPIDateRangeReferenceEnd(state));
    const KPIDateRangeCurrentStart = useSelector((state) => chatGPTReducer.getKPIDateRangeCurrentStart(state));
    const KPIDateRangeCurrentEnd = useSelector((state) => chatGPTReducer.getKPIDateRangeCurrentEnd(state));
    const hasChangedFromDataset = useSelector((state) => chatGPTReducer.hasChangedDateRangeFromDataset(state, datasetId));
    const shouldSyncDatasetDateRange = useSelector((state) => chatGPTReducer.getShouldSyncDatasetDateRange(state));
    const KPIDates = useSelector((state) => chatGPTReducer.getKPIDates(state)) ?? [];
    const KPIDateOptions = useSelector((state) => chatGPTReducer.getKPIDateOptions(state));
    let shouldHaveLabelLookup = false;
    const dateOptions = KPIDateOptions.map((d) => {
        const option = {
            label: d.value,
            value: d.value
        };
        // Only change the label if the timebucket is year or month
        if (timeBucket === "M") {
            const cDate = parse(d.value, "yyyy-MM-dd", new Date());
            // Only change format if the date is the expected date that includes month and date
            if (cDate.toString() !== "Invalid Date") {
                const formatString = timeBucket === "M" ? "yyyy-MM" : "yyyy";
                option.label = format(cDate, formatString);
                shouldHaveLabelLookup = true;
            }
        }
        return option;
    });
    let labelLookup;
    if (shouldHaveLabelLookup) {
        labelLookup = {};
        dateOptions.forEach((o) => {
            if (labelLookup) {
                labelLookup[o.value] = o.label;
            }
        });
    }
    const refStartIndex = KPIDateRangeReferenceStart !== undefined ? KPIDates.indexOf(KPIDateRangeReferenceStart) : 0;
    const refEndIndex = KPIDateRangeReferenceEnd !== undefined ? KPIDates.indexOf(KPIDateRangeReferenceEnd) : 0;
    const currStartIndex = KPIDateRangeCurrentStart !== undefined ? KPIDates.indexOf(KPIDateRangeCurrentStart) : 0;
    const currEndIndex = KPIDateRangeCurrentEnd !== undefined ? KPIDates.indexOf(KPIDateRangeCurrentEnd) : 0;
    const dateIndexRange = [refStartIndex, refEndIndex, currStartIndex, currEndIndex];
    const updateReferenceRange = (dateIndexUpdate) => {
        if (!dateIndexUpdate) {
            return;
        }
        const newDateRange = {
            referenceStart: KPIDateRangeReferenceStart,
            referenceEnd: KPIDateRangeReferenceEnd,
            currentStart: KPIDateRangeCurrentStart,
            currentEnd: KPIDateRangeCurrentEnd
        };
        const newRefStart = KPIDates[dateIndexUpdate[0]];
        const newRefEnd = KPIDates[dateIndexUpdate[1]];
        const newCurrStart = KPIDates[dateIndexUpdate[2]];
        const newCurrEnd = KPIDates[dateIndexUpdate[3]];
        if (newCurrStart !== undefined) {
            newDateRange.currentStart = newCurrStart;
            // if (moment(newCurrStart).isBefore(KPIDateRangeReferenceEnd)) {
            //   newDateRange.referenceEnd = newCurrStart;
            // }
        }
        if (newCurrEnd !== undefined) {
            newDateRange.currentEnd = newCurrEnd;
        }
        if (newRefStart !== undefined) {
            newDateRange.referenceStart = newRefStart;
        }
        if (newRefEnd !== undefined) {
            newDateRange.referenceEnd = newRefEnd;
            // if (moment(newRefEnd).isAfter(KPIDateRangeCurrentStart)) {
            //   newDateRange.currentStart = newRefEnd;
            // }
        }
        dispatch(chatGPTReducer.updateKPIDateRange(newDateRange));
    };
    const updateDate = (dateKey, newDate) => {
        if (newDate !== undefined) {
            dispatch(chatGPTReducer.updateKPIDateRangeValue(dateKey, newDate));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.settingsItem },
            React.createElement("div", { className: styles.settingsItemTitle }, "Date Selection"),
            React.createElement(DateSelector, { dateIndices: dateIndexRange, updateDateIndices: updateReferenceRange, dateArray: KPIDates, labelLookup: labelLookup }),
            React.createElement("div", { className: styles.settingsItemDateWrapper },
                React.createElement(DateInput, { label: "Reference Period", labelIconColor: "#7E69D7", startDate: KPIDateRangeReferenceStart, endDate: KPIDateRangeReferenceEnd, updateStartDate: (v) => updateDate("referenceStart", v), updateEndDate: (v) => updateDate("referenceEnd", v), dateOptions: dateOptions }),
                React.createElement(DateInput, { label: "Current Period", labelIconColor: "#34D399", labelStyle: {
                        justifyContent: "flex-end"
                    }, startDate: KPIDateRangeCurrentStart, endDate: KPIDateRangeCurrentEnd, updateStartDate: (v) => updateDate("currentStart", v), updateEndDate: (v) => updateDate("currentEnd", v), dateOptions: dateOptions })),
            hasChangedFromDataset ? (React.createElement("div", { className: styles.KPIDateInput, style: { marginTop: "10px" } },
                React.createElement("div", { className: styles.settingsItemTitle, style: { marginRight: "10px" } }, "Set Date Selection as Dataset Default"),
                React.createElement(LabledToggle, { style: { display: "block" }, checked: shouldSyncDatasetDateRange, onChange: () => dispatch(chatGPTReducer.updateShouldSyncDatasetDateRange(!shouldSyncDatasetDateRange)), isAibleColors: true }))) : null)));
};
const KPISettings = ({ hideActions }) => {
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    const datasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    const [showAdvancedSettings, updateShowAdvancedSettings] = useState(false);
    return (React.createElement("div", { className: styles.settingsWrapper },
        React.createElement(KPIDatePeriodSelector, null),
        React.createElement("div", { className: styles.settingsItem },
            React.createElement("div", { className: styles.settingsItemTitle }, "Template"),
            React.createElement("div", { className: styles.settingsItemSelect },
                React.createElement(BlueprintSelector, { menuPlacement: "top", filterTypes: ["KPI_ANALYSIS"] }))),
        React.createElement("div", { className: styles.settingsItem },
            React.createElement("div", { className: styles.settingsItemTitle }, "Tone"),
            React.createElement("div", { className: styles.settingsItemSelect },
                React.createElement(ToneSelector, { menuPlacement: "top" }))),
        React.createElement("div", { className: styles.settingsItem },
            React.createElement("div", { className: styles.settingsItemTitle }, "LLM Model"),
            React.createElement("div", { className: styles.settingsItemSelect },
                React.createElement(ModelSelector, { hideIcons: true }))),
        React.createElement("div", { className: styles.settingsItem },
            React.createElement("a", { onClick: () => updateShowAdvancedSettings(!showAdvancedSettings) }, (showAdvancedSettings ? "Hide " : "") + "Advanced Settings")),
        showAdvancedSettings && React.createElement(KPIAdvancedSettings, { datasetId: datasetId }),
        !hideActions && React.createElement(KPISettingsActions, null)));
};
export const KPISettingsActions = ({ buttonText, onClick }) => {
    const dispatch = useDispatch();
    return (React.createElement("div", { className: styles.settingsActions },
        React.createElement(Button, { style: {
                marginLeft: "auto"
            }, type: "primary", onClick: (e) => {
                e.stopPropagation();
                dispatch(chatGPTReducer.refreshKPIAnalysis());
                if (onClick) {
                    onClick();
                }
            } }, buttonText ?? "Apply Settings")));
};
export default KPISettings;
